import config from '@/config/config'
import Store from '@/store'
/* 极验行为 start */
const initGeetest4 = (callback, type) => {
  const captchaId = type === 'getCode' ? config.geetestGetCodeCaptchaId : config.geetestReceiveCaptchaId
  console.log('captchaId======', type, captchaId)
  window.initGeetest4 && window.initGeetest4({
      product: 'bind',
      captchaId,
      hideSuccess: true
  }, (captchaObj) => {
      if (type === 'getCode') {
        window.captchaGetCodeObj = captchaObj
      } else {
        window.captchaObj = captchaObj
      }
      console.log('window.captchaObj====', captchaObj)
      captchaObj.appendTo('#captcha')
          .onReady(() => {
              console.log('ready')
          })
          .onNextReady((ready) => {
              console.log('nextReady', ready)
          })
          .onBoxShow((e) => {
              console.log('boxShow', e)
          })
          .onError((e) => {
              console.log(22, e)
          })
          .onSuccess((res) => {
              console.log('captchaOnSuccess====', res)
              var result = captchaObj.getValidate()
              console.log('result======', result)
              if (!result) {
                  alert('请先完成验证！')
                  return
              }
              const commit = type === 'getCode' ? 'setVerifyCodeInfo' : 'setVerifyInfo'
              Store.commit(commit, result)
              callback()
              captchaObj.reset()
          })
  })
}

const loadGTScript = (callback, type) => {
  var script = document.createElement('script')
  // 1. 监听script的下载的状态 当状态变为下载完成后 再执行 initGeetest4
  script.onload = function () {
      initGeetest4(callback, type)
  }
  // 2. 给script标签添加src 引入一个js文件
  script.src = 'https://static.geetest.com/v4/gt4.js'
  // 3. 追加到body
  document.body.appendChild(script)
}

// 显示极验弹窗
const onShowCaptcha = (callback, type) => {
  console.log('onShowCaptcha type======', type)
  const captchaObj = type === 'getCode' ? window.captchaGetCodeObj : window.captchaObj
  if (captchaObj) {
      console.log('++++++成功', captchaObj.showCaptcha)
      captchaObj.showCaptcha()
  } else {
      const commit = type === 'getCode' ? 'setVerifyCodeInfo' : 'setVerifyInfo'
      Store.commit(commit, { lackType: 'netError' })
      callback()
      return false
  }
}

const getGTHeaders = (type) => {
  console.log('getGTHeaders type======', type)
  let headers = {}
  const result = type === 'getCode' ? Store.state.verifyCodeInfo : Store.state.verifyInfo
  if (result) {
      headers = result.lackType ? { Lacktype: result.lackType } : {
          Lotnumber: result.lot_number,
          Captchaoutput: result.captcha_output,
          Passtoken: result.pass_token,
          Gentime: result.gen_time
      }
  }
  return headers
}
/* 极验行为 end */

export { initGeetest4, loadGTScript, onShowCaptcha, getGTHeaders }



// WEBPACK FOOTER //
// ./src/utils/geetest.js